import React from 'react';

type IconProps = {
  className?: string;
};

/**
 * Glifo "canvi de sentit" (↺, Lucide `rotate-ccw`, ISC) — versión JSX del
 * mismo dibujo usado dentro del marcador fusionado del mapa (mismo path
 * data que `assets/icons/direction-change-icon.svg`, que se inyecta
 * imperativamente vía `innerHTML` en `components/display/Map/_internal.tsx`
 * porque ese contexto es DOM plano, no JSX — ver
 * `createDirectionChangeMarkerContent` ahí). Esta variante existe para la
 * leyenda de MapWithSegments (SR), que SÍ es JSX: mismo `stroke=
 * "currentColor"` que LayersIcon/LocateIcon para heredar el color del
 * contenedor (blanco sobre el swatch de la fila "Cambio de sentido").
 */
export const DirectionChangeIcon = ({ className }: IconProps): JSX.Element => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <polyline points="1 4 1 10 7 10" />
      <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
    </svg>
  );
};
